import { useMemo, useState } from 'react'

/** The first of `items` that was selected when the list mounted, to open scrolled to it. */
export function useFirstInitiallySelectedId(
  items: readonly { id: string }[],
  selectedIds: ReadonlySet<string>,
): string | undefined {
  const [initialIds] = useState(() => new Set(selectedIds))
  return useMemo(
    () =>
      initialIds.size
        ? items.find(item => initialIds.has(item.id))?.id
        : undefined,
    [items, initialIds],
  )
}
